<template>
  <g>
    <path
      d="M7 20.0002C7 20.5502 7.45 21.0002 8 21.0002H16C16.55 21.0002 17 20.5502 17 20.0002V17.0002H7V20.0002Z"
    />
    <path
      d="M18 7.00024C17.45 7.00024 17 7.45024 17 8.00024V5.00024C17 3.90024 16.1 3.00024 15 3.00024H7C5.9 3.00024 5 3.90024 5 5.00024V10.8002C5 10.9302 5.01 11.0602 5.04 11.1902L5.84 15.1902C5.93 15.6602 6.34 15.9902 6.82 15.9902H17.18C17.63 15.9902 18.07 15.6302 18.16 15.1902L18.96 11.1902C18.99 11.0602 19 10.9302 19 10.8002V8.00024C19 7.45024 18.55 7.00024 18 7.00024ZM14 10.0002H8C7.45 10.0002 7 9.55024 7 9.00024V8.00024C7 7.45024 7.45 7.00024 8 7.00024H14C14.55 7.00024 15 7.45024 15 8.00024V9.00024C15 9.55024 14.55 10.0002 14 10.0002Z"
    />
  </g>
</template>
